import { z } from "zod";
// Format into strict ISO 8601
export const isoDate = z
  .union([z.string(), z.date()])
  .transform((val) =>
    typeof val === "string" ? new Date(val).toISOString() : val.toISOString(),
  );

export const nullableIsoDate = z
  .union([z.string(), z.date(), z.null()])
  .transform((val) =>
    val
      ? typeof val === "string"
        ? new Date(val).toISOString()
        : val.toISOString()
      : null,
  );
